/* eslint-disable prettier/prettier */
import LangGenerator from './LangGenerator';

export default LangGenerator({
  translation: {
    in: 'in',
    back: 'Back',
    totalPayment: 'Total Payment',
    successPaymentMessage: 'Your Payment Success',
    failedPaymentMessage: 'Your Payment Failed',
    orderNumber: 'Order Number',
    name: 'Name',
    dateAndTime: 'Date & Time',
    haveQuestion: 'Have a question',
    inHere: 'Check this',
    downloadInvoice: 'Download',
    processClaim: 'Process Claim',
    done: 'Done',
    usePromoCode: 'Use Promo Code',
    enterPromoCodeHere: 'Enter promo code here',
    sorryPromoCode: 'Sorry!',
    failedReasonPromoCode: 'Your promo code is invalid or expired.',
    noPromoCode: 'No Promo Code',
    noPromoCodeInfo:
      'To get a promo code, stay tuned on our events and social media.',
    validUntilPromoCode: 'Valid until',
    promoAdd: 'Add',
    promoRemove: 'Remove',
    selectViaMap: 'Select Via Map',
    useCurrentLocation: 'Use current location',
    locationNotDetected: 'Your location is not detected',
    locationNotDetectedCause:
      'We cannot detect your current location. Please turn on the GPS on your mobile phone.',
    locationNotDetectedCauseBlocked:
      'We don’t have permission to access your location. You can search your address manually or allow Lifepack to access location from your browser settings.',
    searchMyAddress: 'Search My Address',
    turnOnGPS: 'Turn On GPS',
    findMapManually: 'Find Map Manually',
    addDeliveryAddress: 'Add Delivery Address',
    setDeliveryLocation: 'Delivery Location',
    useThisAddress: 'Use This Location',
    lifepackServiceCoverageMistake: "Sorry, it's not you, it's us",
    lifepackServiceIsAvailable: 'Lifepack service is available in',
    lifepackServiceSorry:
      'We are sorry your delivery address is currently outside our coverage area.',
    OK: 'OK',
    searchNearestDeliveryLocation: 'Search your address',
    searchLocation: 'Search street/building/area name',
    searchLocationHelper:
      'Select the nearest location (building, street, district, etc) if your address is not found.',
    selectFromMap: 'Choose from map',
    savedAddressEmptyState:
      "You don't have any saved address. Search your Address to set delivery location.",
    addressNotFound: 'Not Found',
    patientName: 'Patient Name',
    phoneNumber: 'Phone Number',
    membership: 'Membership',
    regular: 'Regular',
    patientAddress: 'Patient Address',
    note: 'Note',
    medicationDate: 'Medication Date',
    medicationList: 'Medication List',
    medicationOnly: 'Medication Only',
    paymentDetail: 'Payment Details',
    subTotal: 'Subtotal',
    memberDiscount: 'Member Discount',
    discount: 'Discount',
    deliveryFee: 'Delivery Fee',
    pickupFee: 'Pickup Fee',
    medicationDiscount: 'Medication Discount',
    enterPromoCode: 'Save more using promo code',
    shippingOption: 'Shipping Option',
    confirm: 'Confirm',
    confirmation: 'Confirmation',
    confirmationDescriptionConsultationOnly:
      'Please check your order before checkout.',
    byPressTermsAndCondition: 'By press continue you agree to our',
    termsAndCondition: 'Terms Condition And Privacy Policy',
    addressNote: 'Location Detail',
    addressNoteExample: 'Write house number, block, RT/RW, etc.',
    durationUnitHours: 'hours',
    durationUnitHour: 'hour',
    durationUnitDays: 'days',
    durationUnitDay: 'day',
    received: 'Received',
    receivedOn: 'Received on',
    afterPickedByCourier: 'after picked up by the courier',
    deliveryDistanceExceedLimit: 'Delivery distance exceeds the limit.',
    serviceNotAvailable: 'Service Not Available',
    promoCantBeApplied: 'This promo code can’t be applied for this order.',
    promoReachMaxUsed: 'This promo code has been used up to the max limit.',
    completeYourPayment: 'Complete Your Payment',
    startFrom: 'Start from',
    close: 'Close',
    chooseLanguage: 'Choose your language',

    medicalProvisions: 'Medical Provisions',
    orderContainsOneOrMoreObatKeras:
      'Your order contains one or more Prescription Drugs (list G / Obat Keras), hence it must be ',
    pickedUpAtOurPharmacy: 'collected at our pharmacy ',
    withIts: ' with its ',
    originalPrescription: 'original prescription',
    doYouAgreeToProceed: 'Do you agree to proceed?',
    b2bAgreeToPickup:
      'I agree to collect my medication at Lifepack Pharmacy (self pickup).',
    b2cAgreeToPickup:
      'I agree to give my original prescription and collect my medication at Lifepack Pharmacy (self pickup).',
    rejectAndCancelOrder: 'Reject & Cancel Order',
    yourOrderWillBeCanceled:
      'Your order will be canceled and you will not be able to reverse this action. You can consult with our doctor to get new prescription for your medication.',
    areYouSureCancelOrder: 'Are you sure you want to reject and cancel order?',
    noRevokeCancelation: 'No, revoke cancelation',
    yesCancelMyOrder: 'Yes, cancel my order',

    pendingAddressTitle: 'Complete Your Order',
    pendingAddressDesc:
      'Please check your Profile & Medication List before you continue.',

    paymentOrderTitle: 'Shipping Confirmation',
    paymentOrderDesc:
      'Please confirm your shipping address and delivery options before you check out. ',

    prescriptionApprovedTitle: 'Prescription Approved',
    prescriptionApprovedDesc:
      'Please check your medication order before you check out.',

    waitingForPaymentTitle: 'Waiting for payment',
    waitingForPaymentDesc: 'Please complete your payment before',

    paymentSuccessfulTitle: 'Payment Successful',
    paymentSuccessfulDesc: 'Thank you, your payment was successful.',

    paymentExpiredTitle: 'Expired',
    paymentExpiredDesc: `Your payment has expired because it's past the due date.`,

    orderCanceledTitle: 'Order Canceled',
    orderCanceledDesc: 'Your order has been canceled as you requested.',

    paymentFailedTitle: 'Payment Failed',
    paymentFailedDesc: 'Your payment was canceled by system.',
    receiptFee: 'Pharmacy Service Fee',

    onDelivery: 'On Delivery',
    inReview: 'In Review',
    prescriptionRejected: 'Rejected',
    orderProcessed: 'On Processed',
    orderCanceled: 'Order Cancelled',
    waitingForPickup: 'Waiting for Pickup',
    pickedUp: 'Picked Up',
    delivered: 'Delivered',
    deliveryFailed: 'Delivery Failed',
    active: 'Active',
    inActive: 'In Active',
    patient: 'Patient',

    paymentMethodNotRegistered:
      "Sorry, user isn't registered as the insured's data.",
    paymentMethod: 'Payment Method',
    choosePaymentMethod: 'Choose payment method',
    pagu: 'Pagu',
    insufficientBalance: 'Insufficient Balance',
    payWithoutPagu: 'Pay without Pagu',
    otherPay: 'Pay',

    change: 'Change',
    contactUs: 'Contact Us',
    checkOut: 'Checkout',
    payNow: 'Pay Now',
    continue: 'Continue',
    timeRemaining: 'Time Remaining',
    promoNotAllPaymentMethod:
      "The promo applied will direct you to specific payment methods and couldn't be changed after checkout.",
    changePaymentMethod: 'Change Payment Method',
    needHelp: 'Need Help? ',
    changeBranch: 'Change Branch?',
    contactLifepackCare: 'Contact Lifepack CS',
    selectFromSavedAddresses: 'Choose from saved addresses',
    pickupAtLifepackPharmacy: 'Pick up at Lifepack Pharmacy',
    deliveryAddress: 'Delivery Address',
    pickupAddress: 'Pickup Address',
    selfPickup: 'Self Pickup',
    mustGiveOriginalPrescription:
      'You must give your original prescription to our pharmacist when taking your medicines.',
    pleaseBringOriginalPrescription:
      'Please bring your original prescription when taking your medicines.',
    yourMedicineCanbePickedUpAt: 'Your medication can be picked up at',
    medicineShouldbePickedUp: 'This medicine must be self-picked up',
    openMap: 'Open Map',
    openGoogleMap: 'Open Google Map',
    payWithPagu: 'Pay with Pagu',
    payWithPartner: 'Pay with Partner',
    patientInformation: 'Patient Information',
    pleaseCompleteYourPayment: 'Please complete your payment',
    transferBefore: 'Transfer before',
    transactionAutomaticallyCanceled:
      'or your transaction is automatically canceled by System.',
    amountPaid: 'Amount Paid',
    transferTo: 'Transfer to',
    totalToBePaid: 'Total To Be Paid',
    copy: 'Copy',
    yourTransactionIsBeingChecked:
      'Your transaction is being checked, Please wait a moment',
    orderInfo: 'Order Info',
    paymenIsMade: 'Payment is made to the a / n account',
    howToPay: 'How to Pay',
    usePaymentWithPagu: 'Use Payment with Pagu',
    usePaymentWithPartner: 'Use Payment with Partner',
    shippingAddressConfirmation: 'Confirm Shipping Address',
    pinpoint: 'Pinpoint',
    fullAddressLabel: 'Full Address',
    fullAddressPlaceholder: 'Input your full address',
    fullAddressHelperText:
      'You can modify the field above to match your exact address.',

    orderExpiredTitle: 'Expired',
    orderExpiredDesc:
      'The system has canceled your order because it’s past the due time.',
    sip: 'License Number (SIP)',
    errorTitleCheckOutNoDeliveryOption: "Sorry, it's not you, it's us.",
    errorMessageCheckOutNoDeliveryOption:
      "We're experiencing a problem in our delivery courier. Please change to other delivery option.",
    consultationFee: 'Consultation Fee',
    locationDetailLabel: 'Location Details (Optional)',
    locationDetailPlaceholder: 'Landmark, house colors, etc',
    saveAddressLabel: 'Save this address for next order',
    savedAddressLabel: 'Address Label',
    savedAddressPlaceholder: 'Ex: Home, Office',
    unsavedAddressPlaceholder: 'This address is not saved',
    confirmAddress: 'Confirm Address',

    unsubscribe: 'Unsubscribe',
    requesting: 'Requesting',
    unsubscribeSuccess: 'Successfuly Unsubscribed',
    operationalHours: 'Operational Hours',
    tax: 'Tax',
    sameDayDeliveryAfter: 'Payment over 14:00, will be delivered tomorrow',

    deleteUser: 'Delete User',
    deleteUserWillRemoveData:
      'Deleting your account will remove your profile and medication history permanently.',
    inputPhoneNumber: 'Enter phone number',
    deleteUserReason: 'Delete User Reason',
    applicationNotWorking: 'The app is not working properly',
    cannotFindMedicine: 'I can’t find my medications',
    manyMedicationNotAvailable: 'Many medications are not available',
    iDontNeed: 'I don’t need it anymore',
    others: 'Other',
    tellUsReason: 'Can you tell us your reason?',
    optional: 'Optional',
    inputOtpCode: 'Input OTP Code',
    inputOtpCodeSentTo: 'Input OTP Code Sent to',
    accountNotFound: 'Account not found',
    accountNotFoundCaption: 'Please enter a registered phone number.',
    resendOtp: 'Resend OTP',
    submit: 'Submit',

    deleteAccountSuccess: 'Delete account successful',
    accountDeletedWishGoodHealth:
      'Your account is successfully deleted. Wishing you good health!',
    deleteAccountFailed: 'Delete account failed',
    problemDeleteAccountContactCS:
      'There is a problem in deleting your account. Please contact Lifepack CS for further information.',
    deleteAccountFailedCaption: 'Please enter a registered phone number.',
    wrongOtp: 'The OTP code you entered is incorrect. Please try again',
    otpSent: 'OTP has been sent',

    quizScore: 'Your Score',
    youHaveATendencyOf: 'You have a tendency of',
    yourCondition: 'Your condition is',
    mildDepression: 'Mild Depression',
    mildDepressionSuggestion:
      'You can still carry out your daily activities, albeit with decreased enthusiasm and interest. Consult with a professional if symptoms worsen.',
    moderateDepression: 'Moderate Depression',
    moderateDepressionSuggestion:
      "You're still managing your daily life, but with difficulty and possibly feeling exhausted by the end of the day. Consider psychotherapy to understand the thoughts, feelings, and symptoms you're experiencing.",
    moderatelySevereDepression: 'Moderately Severe Depression',
    moderatelySevereDepressionSuggestion:
      'You may continue to experience bad moods or worsening physical symptoms. You feel unmotivated and start avoiding activities you once enjoyed. Consult with a Psychiatrist to determine the next steps to take.',
    severeDepression: 'Severe Depression',
    severeDepressionSuggestion:
      'Consult with a psychiatrist immediately for a detailed examination and to receive appropriate assistance. If left unaddressed, severe depression can lead to the loss of loved ones and impair daily functioning.',
    minimalSignDepression: 'Minimal Sign of Depression',
    minimalSignDepressionSuggestion:
      "It is normal to feel sad at times, but if you're feeling consistently burdened, don't keep it to yourself. Opening up by sharing your feelings or consulting with a psychologist/psychiatrist can help you.",

    // ANCHOR: Consultation Forms
    selectDateAndTime: 'Select Date & Time',
    doctorProfile: 'Doctor Profile',
    doctorFee: "Doctor's Fee",
    youCanSelectSeveralConsultation:
      'You can select several consultation schedules according to your availability.',
    next: 'Continue',
    symptomAndCondition: 'Symptom & Condition',
    tellUsWhatYouFeel: 'Tell us what you feel...',
    scheduleConsultation: 'Schedule Consultation',
    inputPatientName: "Input patient's full name",
    selectConsultationDate: 'Select Consultation Date',
  },
});
